import PageContent from 'components/shared/views/PageContent';
import React from 'react';
import PageContainer from "../PageContainer";

import "./styles.css"

export default function LoginPageWrapper(props) {
    const className = props.className ?? "";

    return (
        <PageContainer className={className + " login-page-wrapper"}>
            <PageContent>
                {props.children}
            </PageContent>
        </PageContainer>
    )
}
